'use client';

import { useRouter } from '@bprogress/next/app';
import { ready } from '@payloadcms/live-preview';
import { useEffect, useRef } from 'react';

const getServerURL = () => {
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__.API_PAYLOAD_URL || '';
  }
  return process.env.API_PAYLOAD_URL || '';
};

export const PayloadLivePreview = () => {
  const router = useRouter();
  const sentReady = useRef('');
  const refTimer = useRef(-1);

  const getWindowURL = () =>
    `${window.location.pathname}${window.location.search}`;

  useEffect(() => {
    const serverURL = getServerURL();

    if (!sentReady.current) {
      sentReady.current = getWindowURL();
      ready({ serverURL });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onMessage = (e: any) => {
      if (e.data.type === 'payload-live-preview') {
        window.clearTimeout(refTimer.current);
        refTimer.current = window.setTimeout(() => {
          if (sentReady.current !== getWindowURL()) {
            router.push(sentReady.current);
          } else {
            router.refresh();
          }
        }, 300);
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return null;
};
